import { render, staticRenderFns } from "./Diary.vue?vue&type=template&id=33b38bf8&scoped=true&"
import script from "./Diary.vue?vue&type=script&lang=js&"
export * from "./Diary.vue?vue&type=script&lang=js&"
import style0 from "./Diary.vue?vue&type=style&index=0&id=33b38bf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b38bf8",
  null
  
)

export default component.exports